export const VIEW_GENERAL_SETTINGS_EXPERIENCE_NAME = 'viewEstimationSettings';

export const UPDATE_ESTIMATION_AND_TRACKING_ACTION_SUBJECT = 'updateEstimationAndTracking';
export const UPDATE_ESTIMATION_BROWSER_METRICS_KEY = 'update-estimation';
export const UPDATE_TIME_TRACKING_BROWSER_METRICS_KEY = 'update-time-tracking';

export const ESTIMATION_ACTION_SOURCE = 'estimationMethod';
export const TIME_TRACKING_ACTION_SOURCE = 'timeTracking';
